export default {
    name: 'loginservice',
    dependencies: [],
    callable() {
        return {
            isLoggedIn() {
                return !!document.querySelector("meta[name='FINN.userid']");
            },
        };
    },
};



// WEBPACK FOOTER //
// ./services/loginservice.js